var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { newrelic } from "@jti/fe-clients";
import { getConfig, getLocale } from "@jti/fe-common";
export class YandexApi {
    constructor() {
        this.name = "YandexApi";
    }
    static init() {
        return new YandexApi();
    }
    getSuggestions(query) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                const locale = getLocale();
                const { autocompleteProviderApiUrl } = getConfig();
                const url = new URL(autocompleteProviderApiUrl);
                const queryParams = new URLSearchParams({
                    text: query,
                    print_address: "1",
                    lang: locale,
                    results: "5",
                });
                queryParams.forEach((value, key) => {
                    url.searchParams.set(key, value);
                });
                const response = yield fetch(url.toString());
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = yield response.json();
                return (_a = data.results) !== null && _a !== void 0 ? _a : [];
            }
            catch (error) {
                const errorObject = error instanceof Error ? error : new Error(String(error));
                console.error("Error fetching Yandex suggestions:", errorObject);
                newrelic.noticeError(errorObject);
                return [];
            }
        });
    }
}
//# sourceMappingURL=YandexApi.js.map